/**
 * REAL platform metrics — single source of truth for the marketing site.
 * These numbers must match what a user sees at platform.aigrowthoperator.xyz.
 * DO NOT invent numbers here — if the app changes, update this file.
 */

// Cash impact of approving all safe opportunities on the demo/pilot merchant
export const CASH_IMPACT_USD = 76800;      // +$76.8k
export const CASH_IMPACT_LABEL = "+$76.8k";
export const OPPS_COUNT = 73;

// Live snapshot metrics (example dashboard shown on the marketing site)
export const PROFIT_TODAY_USD = 47600;     // $47.6k
export const ORDERS_PER_DAY = 14.6;
export const AD_SPEND_USD = 12100;         // $12.1k
export const REVENUE_VELOCITY_USD = 88600; // $88.6k
export const NET_MARGIN_PCT = 53.7;
export const ROI_MULTIPLIER = 7.32;        // 7.32x

// Growth Score — 6 pillars
export const GROWTH_SCORE = 74;
export const GROWTH_PILLARS = [
  { name: "Pricing",       score: 82 },
  { name: "Margin",        score: 76 },
  { name: "Ad efficiency", score: 61 },
  { name: "Retention",     score: 88 },
  { name: "SEO",           score: 69 },
  { name: "Creative",      score: 68 },
];

// Product language (verbatim from the app)
export const PRODUCT_TAGLINE = "The CFO at your fingertips.";
export const PRODUCT_SUBLINE = "What changed, why, and what to do next — then implement in one click.";
export const AI_MODEL_LABEL = "Powered by Claude Sonnet 4.6 · grounded in your live Shopify data";

// Operator Modules
export const OPERATOR_MODULES = [
  { name: "Image Engine",    body: "Auto-refreshes product & ad creatives against your brand kit." },
  { name: "SEO Sanitizer",   body: "Fixes metadata, canonicals, and stale content indexed in GSC." },
  { name: "Inventory Guard", body: "Routes spend away from low-stock SKUs. Doubles down on hero products." },
];

// Connectors
export const CONNECTORS = ["Shopify", "Google Ads", "Meta Ads", "GSC", "GA4", "Klaviyo"];

// Formatting
export const fmtUsd = (n) => `$${Math.round(n).toLocaleString()}`;
export const fmtUsdK = (n) => `$${(n / 1000).toFixed(1)}k`;
